export enum OfferPath {
  TalentPool = 'talent_pools',
  Job = 'offers',
}

export enum OfferStatus {
  Draft = 'draft',
  Published = 'published',
  Internal = 'internal',
  Closed = 'closed',
  Archived = 'archived',
}

export enum OfferKind {
  Job = 'job',
  TalentPool = 'talent_pool',
}

export enum StatusChangeType {
  CreateJobTemplate = 'createJobTemplate',
  InsertFromTemplate = 'insertFromTemplate',
  Duplicate = 'duplicate',
  Unarchive = 'unarchive',
  Archive = 'archive',
  Delete = 'delete',
  Publish = 'publish',
  Unpublish = 'unpublish',
  Close = 'close',
  Draft = 'draft',
}
